import Nullstack from 'nullstack';
export default function IconCpuOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cpu-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 5h9a1 1 0 0 1 1 1v9m-.292 3.706a0.997 .997 0 0 1 -.708 .294h-12a1 1 0 0 1 -1 -1v-12c0 -.272 .108 -.518 .284 -.698"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h2v2m0 4h-6v-6"
  }), "   ", Nullstack.element("path", {
    d: "M3 10h2"
  }), "   ", Nullstack.element("path", {
    d: "M3 14h2"
  }), "   ", Nullstack.element("path", {
    d: "M10 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M14 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M21 10h-2"
  }), "   ", Nullstack.element("path", {
    d: "M21 14h-2"
  }), "   ", Nullstack.element("path", {
    d: "M14 21v-2"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}